export const SET_WIN_SERVICES_LIST = "SET_WIN_SERVICES_LIST";
export const SET_WIN_SERVICE_STATUS = "SET_WIN_SERVICE_STATUS";
export const SET_REPORT_QUEUE_RUNNING = "SET_REPORT_QUEUE_RUNNING";
export const SET_REPORT_QUEUE_FULL = "SET_REPORT_QUEUE_FULL";